module.exports = __webpack_public_path__ + "static/img/7.0b311c7f.png";